// This file was automatically generated from appchart.dialog.addEditAmendmentRequest.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.addEditAmendmentRequest');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addEditAmendmentRequest.form = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="add-edit-amendment-request-form" class="el8DialogContainer"><div class="el8FieldSection"><label class="el8label el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Request:</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="requestDescription"></textarea></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong">Conveyed by:</label><div class="el8FieldLongLabelPadding el8Wrap"><select class="w100" name="amendmentSource">');
  var sourceList946 = opt_data.sourceChoices;
  var sourceListLen946 = sourceList946.length;
  for (var sourceIndex946 = 0; sourceIndex946 < sourceListLen946; sourceIndex946++) {
    var sourceData946 = sourceList946[sourceIndex946];
    output.append('<option value="', soy.$$escapeHtml(sourceData946[0]), '">', soy.$$escapeHtml(sourceData946[1]), '</option>');
  }
  output.append('</select></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Status:</span></label><div class="el8FieldLongLabelPadding el8Wrap"><select class="w100" name="status">');
  var statusList954 = opt_data.statusChoices;
  var statusListLen954 = statusList954.length;
  for (var statusIndex954 = 0; statusIndex954 < statusListLen954; statusIndex954++) {
    var statusData954 = statusList954[statusIndex954];
    output.append('<option value="', soy.$$escapeHtml(statusData954[0]), '">', soy.$$escapeHtml(statusData954[1]), '</option>');
  }
  output.append('</select></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Requested on:</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap datePickerWrap fl"><input type="text" class="datePicker" name="requestDate" /></div><div class="el8TextareaWrap el8TimeWrap fl"><input type="text" class="" name="requestTime" /></div></div></form>');
  if (!opt_sb) return output.toString();
};
